import { render, staticRenderFns } from "./TifRutasIndex.vue?vue&type=template&id=475eeda8"
import script from "./TifRutasIndex.vue?vue&type=script&lang=js"
export * from "./TifRutasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports